import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { orderListApi } from 'services/orderManagement';



// Async action to fetch user profile
// 'userProfile/fetchOrderList'---->>>this-name*userProfile/fetchOrderList*--only-unique-identification--like-your--slice-name-and-store-name--
// export const fetchOrderList = createAsyncThunk('fetchOrderList',//--only-unique-identification-
//     async (page = 1, search = '', startDate = '', orderStatus = '', { rejectWithValue }) => {
//         console.log('chal raha???')
//         try {
//             const res = await orderListApi({ page, search, startDate, orderStatus });
//             const { code, data } = res?.data;
//             console.log('data---redux', data)
//             if (code === 200) {
//                 return (data || []);

//             } else {
//                 return rejectWithValue('Failed to fetch user profile'); // Handle error
//             }
//         } catch (error) {
//             return rejectWithValue(error.message); // Handle network errors
//         }
//     }
// );
export const fetchOrderList = createAsyncThunk(
  'order/fetchOrderList', // give it a proper prefix
  async ({ page = 1, search = '', startDate = '', orderStatus = '',orderType = '' }, { rejectWithValue }) => {
    // console.log('chal raha???');
    try {
      const res = await orderListApi({ page, search, startDate, orderStatus ,orderType});
      const { code, data } = res?.data;
      // console.log('data---redux', data);

      if (code === 200) {
        return data || [];
      } else {
        return rejectWithValue('Failed to fetch user profile');
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


const orderSlice = createSlice({
    name: 'order',
    initialState: {
        data: {},
        loading: false,
        error: null,
    },
    reducers: {
        resetOrder: (state) => {
            state.list = null;
            state.loading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchOrderList.pending, (state) => {
                state.loading = true; // When the API call starts
            })
            .addCase(fetchOrderList.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload; // Store the user data
            })
            .addCase(fetchOrderList.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Something went wrong user';
            });
    },
});
export const { resetOrder } = orderSlice.actions;
export default orderSlice.reducer;
